import { MunicipioDTO } from './../../../../entity/MunicipioDTO';
import { Component, OnInit, Input } from '@angular/core';
import { DenunciaService } from 'src/app/service/denuncia/denuncia.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';


@Component({
  selector: 'app-judicial-administrativo',
  templateUrl: './judicial-administrativo.component.html',
  styleUrls: ['./judicial-administrativo.component.css']
})
export class JudicialAdministrativoComponent implements OnInit {

  @Input() visualizacao: boolean;
  @Input() edicao: boolean;
  listaClassificacaoComponente = [];
  charNum = 5000;
  nomeCartorio = null;
  isCartorioExtrajudicialCapital: boolean = false;
  isCartorioExtrajudicialInterior:  boolean = false;
  isServidorInterior: boolean = false;
  isInfanciaJuventude: boolean = false;
  isRacismo: boolean = false;
  isAssedio: boolean = false;

  municipioSelecionado: MunicipioDTO;

  CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_CAPITAL = 52;
  CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_INTERIOR = 53;
  CLASSIFICACAO_SERVIDOR_INTERIOR = 60;
  CLASSIFICACAO_INFANCIA_JUVENTUDE = 159;
  CLASSIFICACAO_ASSEDIO = 157;
  CLASSIFICACAO_RACISMO = 160;
  classificacaoNenhumaOpcaoAnteriorId = 62;
  isTortura: boolean = false;
  CLASSIFICACAO_TORTURA = 154;
  RACISMO = 160;
  charNumVitimas = 500;
  charNumAgressores = 500;
  charNumFuncaoCargoAgressores = 500;
  charNumTestemunhas = 500;
  listaOrigemNotificacaoPublicoExternoComponente = [];
  listaOrigemNotificacaoPublicoInternoComponente = [];
  listaOrgaoVinculadoAgressoresComponente = [];

  tituloRacismo = `<p>O Tribunal de Justiça de Minas Gerais atua para promover a igualdade, o respeito à diversidade e da prevenção do racismo e de outras formas de discriminação racial no ambiente institucional.</p>
<p>Se você é magistrado (a), servidor (a), colaborador (a), trabalhador terceirizado (a) ou estagiário do Tribunal e sofreu ou presenciou situação de racismo ou discriminação racial no ambiente institucional registre o ocorrido por meio do formulário eletrônico.</p>
As denúncias serão recebidas com garantia de sigilo e confidencialidade e encaminhadas às unidades responsáveis para adoção das providências cabíveis.`;



  constructor(
    public service: DenunciaService,
    private desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService) {
  }


  ngOnInit() {

    this.preencherListas();

    if (this.visualizacao || this.edicao) {

     // Caso seja o novo tipo de Denúncia, será analisado a marcação do campo apenas pela única classificação que existirá
     if(this.service.denuncia.controls.listaClassificacao.value.length === 1){
      let classificacaoItem = this.service.denuncia.controls.listaClassificacao.value[0];
      this.marcarCheckClassificacaoEdicaoVisualizacao(classificacaoItem);
     }


     if(this.service.denuncia.controls.listaOrigemNotificacao.value.length > 0
      && this.service.denuncia.controls.publicoOrigemNotificacao.value === 'externo'){
      let origemNotificacaoItem = this.service.denuncia.controls.listaOrigemNotificacao.value;
      this.marcarCheckOrigemNotificacaoPublicoExternoEdicaoVisualizacao(origemNotificacaoItem);
     }

     if(this.service.denuncia.controls.listaOrigemNotificacao.value.length > 0
      && this.service.denuncia.controls.publicoOrigemNotificacao.value === 'interno'){

      let origemNotificacaoItem = this.service.denuncia.controls.listaOrigemNotificacao.value;
      this.marcarCheckOrigemNotificacaoPublicoInternoEdicaoVisualizacao(origemNotificacaoItem);
     }

     if(this.service.denuncia.controls.listaOrgaoVinculadoAgressores.value.length > 0){
      let orgaoVinculadoAgressoresItem = this.service.denuncia.controls.listaOrgaoVinculadoAgressores.value;
      this.marcarCheckOrgaoVinculadoAgressoresEdicaoVisualizacao(orgaoVinculadoAgressoresItem);
     }

    }

  }

  preencherListas() {

    // this.listaClassificacaoComponente = this.service.denuncia.value.listaClassificacaoCompleta
    //   .filter(item => item.assunto.id === this.service.denuncia.value.assunto.id);


      // Obtendo a classificação Nenhuma das opções anteriores, para ser inserido por ultimo na listagem
      //TODO Deverá se verificado uma forma de transformar a classificação Nenhuma das opções anteriores como
      // o ultimo item de qualquer busca por classificação.
      //Ocorrendo problema ao montar a lista, a mesma é reordenada e perde modificação feita no backend.
      var ultimoItemClassificacao = this.service.denuncia.value.listaClassificacaoCompleta
          .find(item => item.id === this.classificacaoNenhumaOpcaoAnteriorId);

      // this.listaClassificacaoComponente = this.service.denuncia.value.listaClassificacaoCompleta
      //   .filter(item => item.assunto.id === this.service.denuncia.value.assunto.id && item.id !== this.classificacaoNenhumaOpcaoAnteriorId);
    this.listaClassificacaoComponente = this.service.denuncia.value.listaClassificacaoCompleta
      .filter(item => item.assunto.id === this.service.denuncia.value.assunto.id && item.id !== this.classificacaoNenhumaOpcaoAnteriorId)
      .sort((a, b) => a.descricao.localeCompare(b.descricao, 'pt-BR'));

        this.listaClassificacaoComponente.push(ultimoItemClassificacao);

  }

  // Método de funcionamento para Checkbox
  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarOutrasOpcoes(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao(item);

  }

  // Método de funcionamento para Radio Button
  checkClassificacaoUmRegistro(item) {
    this.desmarcarOutrasOpcoesService.desmarcarTodasOpcoesExcetoItem(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao(item);
    this.marcarCheckClassificacaoInclusao(item);
  }

  marcarCheckClassificacaoEdicaoVisualizacao(item: any) {
    this.marcarCheckClassificacao(item, false);
  }

  marcarCheckClassificacaoInclusao(item: any) {
    this.marcarCheckClassificacao(item, true);
  }

  marcarCheckClassificacao(item: any, isInclusaoRegistro: boolean) {

    if(isInclusaoRegistro){
      this.limparCampos();
    }

    if(item.id === this.CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_CAPITAL ){
      this.preencheInformacoesCartorioExtrajudicialCapital();

    }else if(item.id === this.CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_INTERIOR){
      if(!isInclusaoRegistro){

        //TODO OS 1285 - Verificar impacto nesta parte com a mudança pro método preencheListaCartoriosPorCodMunicipioCodComarca
        var codigoMunicipio = this.service.denuncia.controls.codigoMunicipio.value;
        var municiopioSelecionado = this.service.denuncia.controls.listaMunicipio.value.find(mun => mun.codigo == codigoMunicipio);
        var codigoComarca = municiopioSelecionado.comrCodigo;
        //console.log('O valor do codigo da comarca: ', codigoComarca);
        this.service.denuncia.controls.codigoComarca.setValue(codigoComarca);
        this.preencheListaCartoriosPorCodMunicipioCodComarca(codigoMunicipio, codigoComarca);

      }
      this.preencheInformacoesCartorioExtrajudicialInterior();

    }
    else if(item.id === this.CLASSIFICACAO_SERVIDOR_INTERIOR){
      this.preencheInformacoesServidorInterior();
    }else if(item.id === this.CLASSIFICACAO_INFANCIA_JUVENTUDE){
      this.preencheInformacoesInfanciaJuventude();
    }
    else if(item.id === this.CLASSIFICACAO_TORTURA){
      this.preencheInformacoesTortura();
    }
    else if(item.id === this.CLASSIFICACAO_ASSEDIO){
      this.preencheAssedio();
    }
    else if(item.id === this.CLASSIFICACAO_RACISMO){
      this.preencheInformacoesRacismo();
    }
    else{
      this.preencheInformacoesOutrasClassificacoes();
    }
  }

  preencheInformacoesOutrasClassificacoes() {
    this.isCartorioExtrajudicialCapital = false;
    this.isCartorioExtrajudicialInterior = false;
    this.isServidorInterior = false;
    this.isInfanciaJuventude = false;
    this.isRacismo = false;
    this.isTortura = false;
    this.isAssedio = false;
  }

  preencheInformacoesServidorInterior() {
    this.isCartorioExtrajudicialCapital = false;
    this.isCartorioExtrajudicialInterior = false;
    this.isTortura = false;
    this.isServidorInterior = true;
    this.isAssedio = false;
    this.isInfanciaJuventude = false;
    this.isRacismo = false;
  }

  preencheInformacoesInfanciaJuventude() {
    this.isCartorioExtrajudicialCapital = false;
    this.isCartorioExtrajudicialInterior = false;
    this.isTortura = false;
    this.isServidorInterior = false;
    this.isInfanciaJuventude = true;
    this.isRacismo = false;
    this.isAssedio = false;
  }

  preencheInformacoesRacismo() {
    this.isRacismo = true;
    this.isCartorioExtrajudicialCapital = false;
    this.isCartorioExtrajudicialInterior = false;
    this.isTortura = false;
    this.isServidorInterior = false;
    this.isInfanciaJuventude = false;
    this.isAssedio = false;
  }

  preencheInformacoesTortura() {

    this.preencherListaOrigemNotificacaoPublicoExterno();
    this.preencherListaOrigemNotificacaoPublicoInterno();
    this.preencherListaOrgaoVinculadoAgressores();

    this.isCartorioExtrajudicialCapital = false;
    this.isCartorioExtrajudicialInterior = false;
    this.isServidorInterior = false;
    this.isTortura = true;
    this.isAssedio = false;
    this.isInfanciaJuventude = false;
    this.isRacismo = false;

    if (this.visualizacao) {
      this.service.denuncia.controls.publicoOrigemNotificacao.disable();
      this.service.denuncia.controls.tipoPessoaNotificante.disable();
      this.service.denuncia.controls.nomeNotificante.disable();
      this.service.denuncia.controls.nomeSocialNotificante.disable();
      this.service.denuncia.controls.cpfCnpjNotificante.disable();
      this.service.denuncia.controls.rgNotificante.disable();
      this.service.denuncia.controls.orgaoExpedidorNotificante.disable();
      this.service.denuncia.controls.ufOrgaoExpedidorNotificante.disable();
      this.service.denuncia.controls.emailNotificante.disable();
      this.service.denuncia.controls.vitimas.disable();
      this.service.denuncia.controls.agressores.disable();
      this.service.denuncia.controls.funcaoCargoAgressores.disable();
      this.service.denuncia.controls.localFato.disable();
      this.service.denuncia.controls.dataHoraFato.disable();
      this.service.denuncia.controls.testemunhas.disable();
      this.service.denuncia.controls.nomeUnidadePrisionalSocioeducativa.disable();
    }

  }
  preencheInformacoesCartorioExtrajudicialInterior() {
    if(!this.edicao){
      this.service.denuncia.controls.codigoCNS.disable();
    }

    this.isCartorioExtrajudicialCapital = false;
    this.isCartorioExtrajudicialInterior = true;
    this.isServidorInterior = false;
    this.isTortura = false;
    this.isAssedio = false;
    this.isInfanciaJuventude = false;
    this.isRacismo = false;
  }

  preencheInformacoesCartorioExtrajudicialCapital(){
    this.service.denuncia.controls.codigoCNS.enable();
    this.isCartorioExtrajudicialCapital = true;
    this.isCartorioExtrajudicialInterior = false;
    this.isServidorInterior = false;
    this.isTortura = false;
    this.isAssedio = false;
    this.isInfanciaJuventude = false;
    this.isRacismo = false;
    this.preencheListaCartoriosBeloHorizonte();
  }

  preencheListaCartoriosBeloHorizonte() {
    this.service.buscarCartoriosBeloHorizonte().subscribe(retorno => {

      if(retorno){
        this.service.denuncia.controls.listaServentia.setValue(retorno);
      }
    })
  }

  preencheListaCartoriosPorCodigoMunicipio(codigoMunicipio: number) {
    this.service.buscarCartoriosPorCodigoMunicipio(codigoMunicipio).subscribe(retorno => {

      if(retorno){
        this.service.denuncia.controls.listaServentia.setValue(retorno);
      }
    })
  }

  preencheListaCartoriosPorCodMunicipioCodComarca(codigoMunicipio: number, codigoComarca: number) {
    this.service.buscarCartoriosPorCodMunicipioCodComarca(codigoMunicipio, codigoComarca).subscribe(retorno => {

      if(retorno){
        this.service.denuncia.controls.listaServentia.setValue(retorno);
      }
    })
  }

  preencheAssedio() {
    this.isAssedio = true;
    this.isCartorioExtrajudicialCapital = false;
    this.isCartorioExtrajudicialInterior = false;
    this.isTortura = false;
    this.isServidorInterior = false;
    this.isInfanciaJuventude = false;
    this.isRacismo = false;
  }

  changeUnidade1(item) {

    this.service.denuncia.controls.listaClassificacao.value.find(each => each.id == item.id).unidade = this.service.denuncia.value.unidadeAux1;

  }

  changeUnidade2(item) {

    this.service.denuncia.controls.listaClassificacao.value.find(each => each.id == item.id).unidade = this.service.denuncia.value.unidadeAux2;

  }

  atribuirListaClassificacao(item) {

    const novaLista = this.listaClassificacaoComponente.filter(lcc => lcc.selecionado);
    novaLista.forEach(c => {

      if ((c.id === 53 || c.id === 60 ) && c.id !== item.id) {

        const selecionado = c.selecionado;
        const classificacao = this.service.denuncia.controls.listaClassificacao.value.find(cl => cl.id === c.id);
        c.unidade = classificacao.unidade;
        c.selecionado = selecionado;

      }

    });

    this.service.denuncia.controls.listaClassificacao.setValue(novaLista);

  }

  contemErro(str) {
    return this.service.denuncia.controls[str].touched &&
      this.service.denuncia.controls[str].errors != null;
  }

  isCheckedCartorioExtrajudicialCapital(){
    return this.isCartorioExtrajudicialCapital;
  }

  isCheckedCartorioExtrajudicialInterior(){
    return this.isCartorioExtrajudicialInterior;
  }

  isCheckedServidorInterior(){
    return this.isServidorInterior;
  }

  isCheckedInfanciaJuventude(){
    return this.isInfanciaJuventude;
  }

  isCheckedRacismo(){
    return this.isRacismo;
  }

  isCheckedTortura(){
    return this.isTortura;
  }

  isCheckedAssedio(){
    return this.isAssedio;
  }

  selecionaComarca(){
    //console.log('O valor do codigoMunicipio: ', this.service.denuncia.controls.codigoMunicipio.value);
    var codigoMunicipio = this.service.denuncia.controls.codigoMunicipio.value;
    this.service.denuncia.controls.codigoComarca.setValue(codigoMunicipio);
  }

  selecionaMunicipio(){
    this.limpaCamposComarcas();
    //console.log('O valor do codigoMunicipio: ', this.service.denuncia.controls.codigoMunicipio.value);
    var codigoMunicipio = this.service.denuncia.controls.codigoMunicipio.value;

    if(codigoMunicipio != ''){
      this.service.denuncia.controls.codigoCNS.enable();

      var municiopioSelecionado = this.service.denuncia.controls.listaMunicipio.value.find(mun => mun.codigo == codigoMunicipio);
      var codigoComarca = municiopioSelecionado.comrCodigo;
      //console.log('O valor do codigo da comarca: ', codigoComarca);
      this.service.denuncia.controls.codigoComarca.setValue(codigoComarca);
      this.service.denuncia.controls.nomeMunicipio.setValue(municiopioSelecionado.nome);
      // Deverá chamar o serviço que buscará as serventias referente ao codigo do municipio
      //this.preencheListaCartoriosPorCodigoMunicipio(codigoMunicipio);
      // TESTE OS 1285
      this.preencheListaCartoriosPorCodMunicipioCodComarca(codigoMunicipio, codigoComarca);

    }else{
      //console.log('Selecionou Selecione o Município');
      this.service.denuncia.controls.codigoCNS.disable();
    }

  }

  selecionaCartorio(){
    //console.log('O valor do codigoCNS', this.service.denuncia.controls.codigoCNS.value);
    // Através da seleção, deverá buscar a devida localidade referente ao cartório
    const codigoCns = this.service.denuncia.controls.codigoCNS.value;

    if(codigoCns != ''){
      const serventia = this.service.denuncia.controls.listaServentia.value.find(cl => cl.codigoCNS === codigoCns);
      //console.log('Serventia selecionada =>', serventia);
      this.service.denuncia.controls.localidade.setValue(serventia.localidade);
      this.service.denuncia.controls.nomeServentia.setValue(serventia.nomeServentia + ' - ' + serventia.nomeMunicipioServentia);
    }else{
      //console.log('Selecionou Selecione o cartório');
      this.service.denuncia.controls.localidade.setValue('');
    }
  }

  limpaCamposComarcas(){
    this.service.denuncia.controls.codigoCNS.setValue('');
    this.service.denuncia.controls.localidade.setValue('');
    this.service.denuncia.controls.listaServentia.setValue([]);
  }

  limparCampos(){
    this.service.denuncia.controls.codigoMunicipio.setValue('');
    this.service.denuncia.controls.codigoCNS.setValue('');
    this.service.denuncia.controls.localidade.setValue('');

    this.service.denuncia.controls.listaServentia.setValue([]);
    this.service.denuncia.get('infancia').reset();

  }


  isTipoNotificantePessoaFisica(): boolean {
    return this.service.denuncia.controls.tipoPessoaNotificante.value === 'fisica';
  }

  isTipoNotificantePessoaJuridica(): boolean {
    return this.service.denuncia.controls.tipoPessoaNotificante.value === 'juridica';
  }

  isListaOrigemNotificacaoPublicoExterno(): boolean {
    return this.service.denuncia.controls.publicoOrigemNotificacao.value === 'externo';
  }

  isListaOrigemNotificacaoPublicoInterno(): boolean {
    return this.service.denuncia.controls.publicoOrigemNotificacao.value === 'interno';
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }

  countCharVitimas(valor, max) {
    this.charNumVitimas = max - valor.length;
  }

  countCharAgressores(valor, max) {
    this.charNumAgressores = max - valor.length;
  }

  countCharFuncaoCargoAgressores(valor, max) {
    this.charNumFuncaoCargoAgressores = max - valor.length;
  }

  countCharTestemunhas(valor, max) {
    this.charNumTestemunhas = max - valor.length;
  }


  // checkboxOrgaoVinculadoAgressores = [
  //   { id: 1, label: 'Departamento Penitenciário - DEPEN/MG/SEJUSP', value: 'Departamento Penitenciário - DEPEN/MG/SEJUSP', checked: false },
  //   { id: 2, label: 'Polícia Militar', value: 'Polícia Militar', checked: false },
  //   { id: 3, label: 'Polícia Civil', value: 'Polícia Civil', checked: false },
  //   { id: 4, label: 'Guarda Municipal', value: 'Guarda Municipal', checked: false },
  //   { id: 5, label: 'Unidade Socioeducativa', value: 'Unidade Socioeducativa', checked: false },
  //   { id: 6, label: 'Outros', value: 'Outros', checked: false }
  // ];

  // getCheckboxOrgaoVinculadoAgressores() {
  //   const valoresCheckboxOrgaoVinculadoAgressores = this.checkboxOrgaoVinculadoAgressores
  //     .filter(item => item.checked)
  //     .map(item => item.value)
  //     .join(', '); // Concatenar com vírgula e espaço

  //   this.service.denuncia.controls.orgaoVinculadoAgressores.setValue(valoresCheckboxOrgaoVinculadoAgressores);
  // }


  preencherListaOrigemNotificacaoPublicoExterno() {
    this.listaOrigemNotificacaoPublicoExternoComponente = this.service.denuncia.value.listaOrigemNotificacaoPublicoExterno;
  }

  checkOrigemNotificacaoPublicoExterno() {
    this.service.denuncia.controls.listaOrigemNotificacao.setValue(this.listaOrigemNotificacaoPublicoExternoComponente.filter(lon => lon.selecionado));
  }

  marcarCheckOrigemNotificacaoPublicoExternoEdicaoVisualizacao(origemNotificacaoItem: any) {

    this.listaOrigemNotificacaoPublicoExternoComponente = this.service.denuncia.value.listaOrigemNotificacaoPublicoExterno;

   if (origemNotificacaoItem.length > 0) {
     origemNotificacaoItem.forEach(origemNotificacaoItem => {
       const itemSelecionado = this.listaOrigemNotificacaoPublicoExternoComponente.find(item => item.id === origemNotificacaoItem.id);

       if (itemSelecionado) {
         itemSelecionado.selecionado = true;
       }
     });
   }
 }

  preencherListaOrigemNotificacaoPublicoInterno() {
    this.listaOrigemNotificacaoPublicoInternoComponente = this.service.denuncia.value.listaOrigemNotificacaoPublicoInterno;
  }

  checkOrigemNotificacaoPublicoInterno() {
    this.service.denuncia.controls.listaOrigemNotificacao.setValue(this.listaOrigemNotificacaoPublicoInternoComponente.filter(lon => lon.selecionado));
  }

  marcarCheckOrigemNotificacaoPublicoInternoEdicaoVisualizacao(origemNotificacaoItem: any) {

     this.listaOrigemNotificacaoPublicoInternoComponente = this.service.denuncia.value.listaOrigemNotificacaoPublicoInterno;

    if (origemNotificacaoItem.length > 0) {
      origemNotificacaoItem.forEach(origemNotificacaoItem => {
        const itemSelecionado = this.listaOrigemNotificacaoPublicoInternoComponente.find(item => item.id === origemNotificacaoItem.id);

        if (itemSelecionado) {
          itemSelecionado.selecionado = true;
        }
      });
    }
  }

  preencherListaOrgaoVinculadoAgressores() {
    this.listaOrgaoVinculadoAgressoresComponente = this.service.denuncia.value.listaOrgaoVinculadoAgressoresCompleta;
  }

  checkOrgaoVinculadoAgressores() {
    this.service.denuncia.controls.listaOrgaoVinculadoAgressores.setValue(this.listaOrgaoVinculadoAgressoresComponente.filter(lova => lova.selecionado));
  }

  marcarCheckOrgaoVinculadoAgressoresEdicaoVisualizacao(orgaoVinculadoAgressoresItem: any) {

    this.listaOrgaoVinculadoAgressoresComponente = this.service.denuncia.value.listaOrgaoVinculadoAgressoresCompleta;

   if (orgaoVinculadoAgressoresItem.length > 0) {
       orgaoVinculadoAgressoresItem.forEach(orgaoVinculadoAgressoresItem => {
       const itemSelecionado = this.listaOrgaoVinculadoAgressoresComponente.find(item => item.id === orgaoVinculadoAgressoresItem.id);

       if (itemSelecionado) {
         itemSelecionado.selecionado = true;
       }
     });
   }
 }

 isPainelOperador(){
    return !this.authService.isUsuarioExternoLogado() && !this.authService.isUsuarioGovBr();
 }

}
